import React from 'react' 
import { TransitionAnimation, TransitionAnimationProps } from '../TransitionAnimation'


export const Animation = ({children, ...props}) => (
    <TransitionAnimation {...props}>
        {children}
    </TransitionAnimation>
)

Animation.propTypes = TransitionAnimationProps